import { render, staticRenderFns } from "./centerSCPersonManage.vue?vue&type=template&id=8b7a4ca6&scoped=true&"
import script from "./centerSCPersonManage.vue?vue&type=script&lang=js&"
export * from "./centerSCPersonManage.vue?vue&type=script&lang=js&"
import style0 from "./centerSCPersonManage.vue?vue&type=style&index=0&id=8b7a4ca6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7a4ca6",
  null
  
)

export default component.exports